<template>
  <div id="main-content" class="student-list">
    <el-row>
      <el-col :offset="1" :span="22">
        <PageTitle :title="title" :backLink="backLink"></PageTitle>
        <el-form :inline="true" class="d-flex justify-space-between">
          <el-form-item>
            <span class="label-search">{{$t('fileM.search')}}</span>
            <input type="text" @keyup.enter="onSearchData" v-model="searchText" class="input_search1" :placeholder="$t('fileM.placeholder')">
            <el-select @change="onSearchData" class="select-search" v-model="filter.category_ids" :placeholder="$t('categoryM.name')">
              <el-option v-for="(cate, index) in listCategory" :key="cate.id" :label="index===0 ? $t(cate.name) : cate.name"  :value="cate.id">
                {{index===0 ? $t(cate.name) : cate.name}}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onAddFile">+ {{ $t('fileM.create') }}</el-button>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <table class="bus-list mt-4">
              <tr>
                <th width="5%">#</th>
                <th width="20%">
                  <div class="d-flex justify-center">
                    <span>{{ $t('fileM.title') }}</span>
                    <Sort :model="sort.name" @change="changeSort($event, 'name')"></Sort>
                  </div>
                </th>
                <th width="12%">
                  {{$t('fileM.password')}}
                </th>
                <th width="14%">
                  <div class="d-flex justify-center">
                    <span>{{ $t('fileM.categoryName') }}</span>
                    <Sort :model="sort.name" @change="changeSort($event, 'name')"></Sort>
                  </div>
                </th>
                <th width="20%">{{ $t('fileM.note') }}</th>
                <th width="8%">
                  <div class="d-flex justify-center">
                    <span>{{ $t('categoryM.created_at') }}</span>
                    <Sort :model="sort.created_at" @change="changeSort($event, 'created_at')"></Sort>
                  </div>

                </th>
                <th width="8%">
                  <div class="d-flex justify-center">
                    <span>{{ $t('categoryM.updated_at') }}</span>
                    <Sort :model="sort.updated_at" @change="changeSort($event, 'updated_at')"></Sort>
                  </div>
                </th>
                <th></th>
              </tr>
              <tbody>
                <tr v-for="(item, index) in list" :key="index">
                  <td scope="row" width="5%">{{ (dataPage.current_page -1)*dataPage.limit + index+1}}</td>
                  <td>{{item.title}}</td>
                  <td>
                    <el-form>
                      <el-switch class="mr-1" :inactive-value="0" :active-value="1" v-model="item.status"></el-switch>
                      <el-input show-password :value="item.password" style="width: 70%"></el-input>
                    </el-form>
                  </td>
                  <td>{{onGetCate(item.category_id)}}</td>
                  <td>{{item.note}}</td>
                  <td>{{item.created_at ? formatDateTime('YYYY/MM/DD HH:mm:ss', item.created_at) : ''}}</td>
                  <td>{{item.updated_at ? formatDateTime('YYYY/MM/DD HH:mm:ss', item.updated_at) : ''}}</td>
                  <td>
                    <b-button variant="outline-primary" class="mr-2" @click="onDetailFile(item)">{{ $t('common.detail') }}</b-button>
                    <b-button  variant="danger" class="mr-2" @click="onDelete(item)">{{ $t('common.delete') }}</b-button>
                    <b-button v-if="item.is_disable ===0"   variant="warning" class="mr-2" @click="onDisabled(item)">{{ $t('common.disable') }}</b-button>
                    <b-button v-else variant="primary"  class="mr-2" @click="onDisabled(item)">{{ $t('common.enable') }}</b-button>
                    <el-button type="success" icon="el-icon-view" @click="goToViewFile(item.file_url)">{{ $t('common.view') }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </el-col>
        </el-row>
        <el-row style="padding-top: 15px">
          <el-pagination
              background
              @current-change="didSelectPage"
              :page-size="dataPage.limit"
              layout="prev, pager, next"
              :current-page="page"
              :total="dataPage.total">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
import Sort from "@/components/Sort";
import {formatDateTime} from '@/utils'
import {ITEM_PER_PAGE} from "@/config";
export default {
  components:{
    PageTitle,
    Sort
  },
  data(){
    return {
      title:'fileM.titleList',
      backLink: ``,
      listCategory: [],
      searchText: '',
      page: 1,
      itemPerPage: ITEM_PER_PAGE,
      filter:{
        category_ids: 0,
      },
      sort: {
        name: null,
        created_at: null,
        updated_at:null
      },
      list: [],
      dataPage :  {
        limit: 10
      },
    }
  },
  created() {
    this.onGetListCaterories()
  },
  methods:{
    onDetailFile(item){
      this.$router.push({name: 'category-management-id', params:{id: item.category_id}, query:{file_id: item.id}})
    },
    onSearchData(){
      this.page = 1
      this.onGetListCaterories()
    },
    goToViewFile(file_url) {
      window.open(file_url, '_blank')
    },
    didSelectPage: function (e) {
      this.page = e
      this.onGetListFiles()
    },
    onGetCate(cate_id){
      if(cate_id){
        let index= this.listCategory.findIndex(el => el.id === cate_id)
        if(index > -1){
          return this.listCategory[index].name
        }
      }else{
        return  ''
      }
    },
    onDelete(item){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            if (this.list.length <= 1) {
              this.page = this.page > 1 ? this.page - 1 : 1
            }
            this.onGetListFiles()
            this.$notify({
              title: this.$t('msg.titleSuccess'),
              message: this.$t('msg.contentDeleteSuccess', { field: this.$t('nameField.file') }),
              type: 'success'
            })
          }
        },
        errorCallback: () => {},
        file_id: item.id
      }
      this.$store.commit('openConfirm', {
        title: this.$t('common.delete'),
        message: this.$t('msg.deleteConfirm', {field: this.$t('nameField.file')}),
        callback: () => {
          this.$store.dispatch('CategoriesFile/deleteFile', payload)
        }
      })
    },
    onDisabled(item){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.onGetListFiles()
            this.$notify({
              title: this.$t('msg.titleSuccess'),
              message: item.is_disable ? this.$t('msg.contentEnableSuccess', { field: this.$t('nameField.file') }) : this.$t('msg.contentDisableSuccess', { field: this.$t('nameField.file') }),
              type: 'success'
            })
          }
        },
        errorCallback: () => {},
        file_id: item.id
      }
      this.$store.commit('openConfirm', {
        title: item.is_disable ? this.$t('common.enable') : this.$t('common.disable'),
        message: item.is_disable ? this.$t('msg.enableMessage', {field: this.$t('nameField.file')}) :  this.$t('msg.disableMessage', {field: this.$t('nameField.file')}),
        callback: () => {
          this.$store.dispatch('CategoriesFile/disableFile', payload)
        }
      })
    },
    onEdit(id){
      this.$router.push({name: 'category-management-id', params:{id: id}})
    },
    formatDateTime(param, value){
      return formatDateTime(param, value)
    },
    onAddFile(){
      this.$router.push('/file-management-create')
    },
    changeSort (type, field) {
      this.sort[field] = type
      this.sort = Object.assign({}, this.sort)
      this.onGetListCaterories()
    },
    onGetListCaterories(){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.listCategory = response.data.data.data_list
            this.listCategory.unshift({id:0, name: 'fileM.allCate'})
            this.onGetListFiles()
          }
        },
        errorCallback: () => {},
      }
      this.$store.dispatch('CategoriesFile/getListCategory', payload)
    },
    onGetListFiles(){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.list = response.data.data.data_list
            this.dataPage = response.data.data
          }
        },
        errorCallback: () => {},
        sort: this.sort,
        search: this.searchText,
        filter: this.filter,
        page: this.page
      }
      this.$store.dispatch('CategoriesFile/getListFile', payload)
    },
    swapCaterories(e){
      let data = {}
      let oldIndex = parseInt(e.oldIndex) || 0
      let newIndex = parseInt(e.newIndex) || 0
      if(e.oldIndex !== e.newIndex){
        data.drag = this.list[oldIndex].id
        data.drop = this.list[newIndex].id
      }
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.onGetListCaterories()
          }
        },
        errorCallback: () => {},
        data:data
      }
      this.$store.dispatch('CategoriesFile/swapCategory', payload)
    }
  }
}
</script>
<style lang="scss">
.justify-center{
  justify-content: center;
}
.input_search1{
  width: 50vw;
  margin: 0 1.3rem;
  border: 1px solid #000000;
  border-radius: 4px;
  padding-left: .5rem;
  font-size: 1rem;
  height: 40px;
  &:focus{
    border: 1px solid #000000 !important;
  }
  &:focus-visible{
    outline: none;
  }
  &::placeholder{
    opacity: .5;
    font-size: .9rem;
  }
}
.label-search{
  font-size: 1.2rem;
  padding-top: .3rem;
  font-weight: 600;
}
.select-search{
  margin-right: 1.5rem;
  font-size: 1rem;
  input{
    border: 1px solid #000000 !important;
    font-size: 1rem;
  }
}
.el-select-dropdown__item.selected{
  background-color: #5ca3ec !important;
  color:white !important;
}
</style>
